module.exports = __webpack_public_path__ + "static/media/taeyong-4.jpeg";